<script setup lang="ts">
/**
 * UI-kit component
 * Category: Footers
 * Name: FooterPaymentBadge
 * FIGMA: https://www.figma.com/design/NgI2cVJkWODrgnOBHO3Zed/Strapi-Builder--DS-?node-id=3064-785
 *
 * A 52x24 payment-method chip for the footer's "We accept" row. The chips ship as
 * committed Figma exports (licensed logos — never recolor); chips per row follow
 * the column width, not the breakpoint. stripe replaced klarna in the set.
 * Local implementation of the Figma DS component missing from @brighterly/lib-lumee-ui (dsGap).
 */
// types
import type { FooterPaymentBadgeProps } from '../types/interfaces'
// hooks
import { useFooterPaymentBadge } from '../composables/use-footer-payment-badge.hook'

defineOptions({
  name: 'FooterPaymentBadge',
})

const props = defineProps<FooterPaymentBadgeProps>()

const {
  refSrc,
} = useFooterPaymentBadge({ props })
</script>

<template>
  <img
    class="footer-payment-badge"
    :src="refSrc"
    :alt="method"
    width="52"
    height="24"
  >
</template>

<style lang="scss" scoped src="../styles/_footer-payment-badge.scss" />
